import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import InterestedBoxTemplate from './InterestedBoxTemplate';
import { rem } from 'polished';
import { Pages } from '../../../types/pages';

export const InterestedBoxStyled = styled(InterestedBoxTemplate)`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${rem(32)};

    .legals {
        width: 100%;
        margin-bottom: ${rem('30px')};
        .checkbox-wrapper {
            width: 100%;
            .checkboxWrapper > .checkbox-label {
                width: 100%;
                display: flex;
            }
        }
    }

    .reinsurance,
    .dealerShare {
        display: flex;
        align-items: center;
        margin-bottom: unset;
        color: ${({ theme }) => theme.colors.black2};
        background: none;
        padding: 0;
        border: none;
    }

    .dealerShare {
        margin-bottom: ${rem(32)};
        cursor: pointer;
        border-bottom: 1px solid ${({ theme }) => theme.colors.black2};
    }

    .btn-section {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-bottom: ${rem(32)};
        gap: ${rem(30)};

        @media (min-width: ${breakpoints.md}px) {
            flex-direction: row;
            width: ${rem(600)};
        }

        ${({ fullWidth }) =>
            fullWidth &&
            `
        
                @media (min-width: ${breakpoints.md}px) {
                    flex-direction: column-reverse;
                    width: 100%;
                }
          `}
    }

    .links-section {
        width: 100%;

        .section {
            background: ${({ theme }) => theme.colors.grey6};
            border-radius: ${rem(12)};
            padding: ${rem(24)};
            position: relative;
            margin-bottom: ${rem(20)};

            ${({ page }) =>
                page === Pages.basketV2 &&
                `
                    @media (min-width: ${breakpoints.md}px) {
                        .flexible {
                            display: flex;
                            justify-content: space-between;
                         
                            .left {
                                width: 50%;
                            }
                          
                            .right {
                                width: 50%;
                                margin-top: ${rem(25)};
                            }
                        }
                }
            `}

            .title {
                font-size: ${rem(24)};
                color: ${({ theme }) => theme.colors.black2};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            .description1 {
                font-size: ${rem(14)};
                color: ${({ theme }) => theme.colors.black2};
                line-height: ${rem(18)};
                margin: ${rem(4)} 0 ${rem(20)} 0;
            }

            .phone {
                font-size: ${rem(20)};
                color: ${({ theme }) => theme.colors.blue2};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                display: flex;
                align-items: center;

                svg {
                    width: ${rem(40)};
                    height: ${rem(35)};
                    margin-bottom: -${rem(5)};

                    path {
                        fill: ${({ theme }) => theme.colors.blue2} !important;
                    }
                }
            }

            .description2 {
                font-size: ${rem(14)};
                color: ${({ theme }) => theme.colors.grey1};
                line-height: ${rem(18)};
                margin: ${rem(6)} 0 ${rem(16)} 0;
            }
        }

        .legal-text {
            color: ${({ theme }) => theme.colors.grey1};
            font-size: ${rem(12)};
        }
    }
`;
